<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel">
      <h3 slot="header" class="modal-header">凭证列表</h3>
      <ul>
        <li v-for="item in data"  class="flex mb8 " style="justify-content: space-between">
          <a href="javascript:;" @click.stop="showImg(item)">{{item.attachmentName}}</a>
          <Button type="primary" size="small" @click.stop="delItem(item.fid)"> 删除</Button>
          
        </li>
        

      </ul>
      <div slot="footer"></div>
    </Modal>

  </div>


</template>
<script>
  import {getVouchers,delVouchers} from "../../../../../api/contractList";

  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      },

    },
    created(){
      this.getVouchers()

    },
    watch:{
      n(){
        this.data=[]
        this.isShow=true
        this.getVouchers()
      }
    },
    data(){
      return {
        loading: true,
        isShow:false,
        data:[]
      }
    },
    methods:{
      showImg(item){
        this.$showImg(item.attachmentImgUrl)

      },
      delItem(fid){
        let params={
          fid:fid
        }
        delVouchers(params).then(res=>{
          this.$Message.success('删除成功')
          this.getVouchers()
        }).catch(error=>{})

      },
      getVouchers(){
        if(!this.fid){
          return

        }
        let params={
          surrenderFid:this.fid
        }
        getVouchers(params).then(res=>{
          if(!res.data){
            return
          }
          this.data=res.data
          this.$emit('num',this.data.length)

        }).catch(error=>{})

      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){

      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

</style>
